import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowRight, Play, MapPin } from "lucide-react";
import { heroImage, churchInfo } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const defaultHp = {
  hero_eyebrow: "Assemblies of God",
  hero_title_line1: "A river of life",
  hero_title_italic: "flowing through",
  hero_title_line3: "West Texas.",
  hero_description: "Welcome to First Assembly Living Waters \u2014 a Spirit-filled family in Big Spring, TX, where every soul matters and every story finds hope in Jesus.",
  hero_primary_cta_label: "Plan Your Visit",
  hero_primary_cta_href: "#visit",
  next_service_label: "Next Service",
  next_service_value: "Sunday \u00b7 10:45 AM",
};

export default function Hero() {
  const [hp, setHp] = useState(defaultHp);
  const [info, setInfo] = useState(churchInfo);
  useEffect(() => {
    axios.get(`${API}/homepage`).then(r => { if (r.data) setHp({ ...defaultHp, ...r.data }); }).catch(() => {});
    axios.get(`${API}/contact-info`).then(r => { if (r.data) setInfo({ ...churchInfo, ...r.data }); }).catch(() => {});
  }, []);

  return (
    <section className="relative min-h-[100svh] w-full overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImage} alt="Worship" className="h-full w-full object-cover kenburns" />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-20 pt-40 md:pt-48 pb-24 max-w-7xl mx-auto">
        <div className="max-w-3xl fade-in-up">
          <div className="flex items-center gap-3 text-[#c8a36a] mb-6">
            <div className="h-px w-10 bg-[#c8a36a]" />
            <span className="uppercase tracking-[0.32em] text-xs font-semibold">{hp.hero_eyebrow}</span>
          </div>
          <h1 className="text-white text-5xl md:text-7xl lg:text-[88px] leading-[1.02] font-bold tracking-tight">
            {hp.hero_title_line1}<br />
            <span className="text-[#f0d9a8] font-bold">{hp.hero_title_italic}</span><br />
            {hp.hero_title_line3}
          </h1>
          <p className="mt-8 text-lg md:text-xl text-white/85 max-w-xl leading-relaxed">
            {hp.hero_description}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a href={hp.hero_primary_cta_href || "#visit"} className="btn-gold rounded-full px-7 py-3.5 font-semibold inline-flex items-center gap-2">
              {hp.hero_primary_cta_label || "Plan Your Visit"} <ArrowRight className="h-4 w-4" />
            </a>
            <a href="/videos" className="inline-flex items-center gap-3 text-white/90 hover:text-[#f0d9a8] transition-colors group">
              <span className="h-12 w-12 rounded-full border border-white/40 flex items-center justify-center group-hover:bg-white/10 group-hover:border-[#f0d9a8]">
                <Play className="h-4 w-4 ml-0.5" />
              </span>
              <span className="font-medium">Watch Latest Sermon</span>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 inset-x-0 z-10 hidden md:flex justify-between items-end px-12 lg:px-20 pb-10 text-white/85">
        <div className="flex items-center gap-2 text-sm">
          <MapPin className="h-4 w-4 text-[#c8a36a]" />
          <span>{info.address}</span>
        </div>
        <div className="text-right">
          <div className="text-xs uppercase tracking-[0.3em] text-[#c8a36a]">{hp.next_service_label}</div>
          <div className="text-2xl font-bold mt-1">{hp.next_service_value}</div>
        </div>
      </div>

      <div className="absolute bottom-0 inset-x-0 water-line" />
    </section>
  );
}
